


























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { create } from '@/util/createApi';
@Component({
  components: {},
})
export default class RadioInput extends Vue {
  @Prop(Number) unitId: any;
  private dataText: any = '123123';
  private drawer = false;

  private form: any = {
    title: '多选框',
    placeholder: '请选择',
    optionsTile: false,
    required: false,
  };

  closeTap() {
    console.log(this.unitId);
    this.$emit('i_close', { id: this.unitId });
  }
}
